export const MainServicesArray = [
  {
    id: 1,
    title: 'UGC Creation',
    description: 'Professional video commercials and user-generated content to help brands connect with audiences worldwide.',
    slug: 'commercials',
  },
  {
    id: 2,
    title: 'Commercials',
    description: 'Professional video commercials and user-generated content to help brands connect with audiences worldwide.',
    slug: 'commercials',
  },
  {
    id: 3,
    title: 'Fitness Coaching',
    description: 'Personalized coaching programs including clarity sessions, 4-week resets, and 8-week transformations.',
    slug: 'wellness-coaching',
  },
  {
    id: 4,
    title: 'Wellness Coaching',
    description: 'Personalized coaching programs including clarity sessions, 4-week resets, and 8-week transformations.',
    slug: 'wellness-coaching',
  },
  {
    id: 5,
    title: 'Mental Wellness',
    description: 'Guidance in stress management, balance, and personal growth through practical and compassionate coaching.',
    slug: 'mental-wellness',
  },
];
